// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginComponent_loginPage__U7zCw"};